import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { MenuPayload, MenuResponse } from "@/types/interface/menu";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { mapOptionMultiselect } from "@/utils/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useMenuStore } from "@/stores/master/menu";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateMenu',
  setup(__props) {

const idMenu = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const menuStore = useMenuStore();
const detailMenu = ref<MenuResponse>();
const listParentMenu = ref<any>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    url: zod.string().nonempty({ message: "Url is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: url } = useField<string>("url");
const { value: icon } = useField<string>("icon");
const { value: slug } = useField<string>("slug");
const { value: parent_id } = useField<number>("parent_id");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadMenu: MenuPayload = {
    name: name.value,
    url: url.value,
    icon: icon.value,
    slug: slug.value,
    parent_id: parent_id.value?.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await menuStore.dispatchUpdate(
      idMenu.value,
      payloadMenu
    );
  } else {
    responseApi.value = await menuStore.dispatchCreate(payloadMenu);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value ? "Menu Successfully Updated" : "Menu Successfully Added"
      );
      router.push("/master/menu");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadListMenuParent = async () => {
  const { success, message } = await menuStore.dispatchGetAll(1, 99);
  if (success) {
    listParentMenu.value = mapOptionMultiselect(
      menuStore.menus?.items,
      "id",
      "name"
    );
  }
};

const loadDetailMenu = async () => {
  const { success, message } = await menuStore.dispatchDetail(idMenu.value);
  if (success) {
    detailMenu.value = await menuStore?.menu?.data;
    name.value = detailMenu.value?.name;
    url.value = detailMenu.value?.url;
    slug.value = detailMenu.value?.slug;
    icon.value = detailMenu.value?.icon;
    parent_id.value = mapOptionMultiselect(
      detailMenu.value?.parent,
      "id",
      "name"
    );
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idMenu.value = router.currentRoute.value.params.id.toString();
    loadDetailMenu();
  }
  loadListMenuParent();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Menu"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/menu"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Menu ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "url",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Url "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "url",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(url) ? (url).value = $event : null)),
                          placeholder: "Url",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(url)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).url), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "icon",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Icon "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          name: "icon",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(icon) ? (icon).value = $event : null)),
                          placeholder: "icon",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(icon)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).icon), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "parent_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Menu Parent "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(parent_id),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(parent_id) ? (parent_id).value = $event : null)),
                          options: listParentMenu.value,
                          placeholder: "Menu Parent"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).parent_id), 1)
                    ])
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})